<style scoped>
@import '../../css/base/variables.css';
.gencode {
    padding: 0 0 30px 0;
}
.check-type-select,
.page-type-select {
    overflow: hidden;
    padding-bottom: 20px;

    & > * {
        vertical-align: middle;
    }
}

.type-label {
    margin-left: 5px;
    margin-right: 15px;

    & > * {
        vertical-align: middle;
    }
}
.check-btns a:hover {
    color: var(--primary-color);
    opacity: .7;
}

.ps {
    margin-left:  15px;
    color: #999;
}
img {
    vertical-align: middle;
}

.ck-tips {
  position: relative;
  width: 714px;
  margin: 30px 0 0 10px;
  padding: 30px 20px;
  background: #f5f5f5;
  color: #868ca7;
  font-size: 12px;
}
.ck-tips:before {
  content: '';
  position: absolute;
  top: -6px;
  left: -6px;
  width: 38px;
  height: 24px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAYCAMAAAChk39BAAAAllBMVEVHcEzk5OTk5OTk5OTk5OTk5OTk5OTk5OTk5OTk5OTk5OTk5OTk5OTk5OTk5OTk5OTk5OTk5OTk5OTk5OTk5OTk5OTk5OTk5OTk5OTk5OTk5OTk5OTk5OTk5OTk5OTk5OTk5OTk5OTk5ORydoXKys2lp66EiJN7f42eoKi0truNkJrX19nDxMfe3t6tr7XQ0dOVmKG8vcEtMmMaAAAAInRSTlMABuGCwWYoWI5yM6qaPPnYQQykEhvQuO3K77NKIk15e/JLzfLiQAAAARNJREFUeNqF0dmSgjAQBVDZV4FRFMfZu0MIi6D//3PTIVDUFDi5D02KPoSHu/sneegF/vX0etzcGvne+4rPaQJTwr9rN3Osg21O6yXeuH5xPxw/upjwLJ+jAl1iyVwtsyXLtMyUzANtDGIBPTtU6beZS8xXxwfKWfMt9kPsMLMWniUgZqsjG5kQwBvEEmAoG+zqCmR8YqliAzKadwEVHxh2DEVb1b1iV2LfirWKlcDpqqruUJQ3mJKqEhbWzEz+tJpdspRwwwdNTkxAN37CkE0/hXyXzUzd1gNHxBpKmgLqiWXrEvgdVnFkCXpmzSUsacSaRbIEfS6yBH0KKmGVpDBP9jmKfStwvLd9+H40dsXGu3V+AQGFY/kgD6ckAAAAAElFTkSuQmCC) no-repeat center;
}

.ck-example {
  margin: 10px 15px;
  color: #abaebb;
}
.ck-example >  p {
  margin: 0;
}

.ck-step {
  padding-left: 8px;
  background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADCAMAAABh9kWNAAAADFBMVEWGi6iGi6iGi6iGi6hYxDLsAAAAA3RSTlP0hfnKLjlkAAAAF0lEQVR42gEMAPP/AAEAAQACAwAAAQABAEQACmuZC4IAAAAASUVORK5CYII=) no-repeat 0 8px;
}
</style>

<template lang="pug">
.content-part
    .gencode
        domain-select
        .check-type-select 
            span 检查代码类型：
            label.type-label(v-for="type,idx in ckTypes")
                input(
                    type="radio",
                    name="currCkType",
                    :value="idx",
                    :checked="currCkTypeIdx === idx",
                    @change="currCkTypeIdx = idx"
                )
                i
                span {{type.desc}}
        .page-type-select
            span 输入检查页面：
            input.size-big(
                type="text",
                placeholder="请输入页面URL，如http://fen.360.cn/setting",
                v-model="usrUrl",
                ref="input"
            )
            v-tooltip(:tip="ckTypes[currCkTypeIdx].tip", pos="right")
                i.fa.fa-question-circle(style="font-size: 18px;")
        .check-btns
            input.btn.btn-primary.btn-medium(type="button", value="开始检查", @click="doCheck")
            a.btn.btn-white.btn-medium(href="/help/manual?target=check", target="_blank") 手动检查
        .ck-tips(v-show="currCkTypeIdx === 0")
            .ck-step
               p 若您的网站不支持iframe嵌套，则无法使用代码自动检查功能，请选择手动检查。
        .ck-tips(v-show="currCkTypeIdx === 1")
            .ck-step 检查商品、订单、购物车回传代码中的任意代码，都同时会检测基础流量代码，因为基础流量代码是其他代码生效的基础。
            .ck-example
               p 【示例】若您想监测商品回传、订单回传代码：
               p (1) 输入想要检查的商品页面URL；
               p (2) 点击“开始检查”后进入该页面，然后从该页面开始实际进行下单操作流程，直到下单完成，代码检查结果会在页面上直接显示，也可在页面点击返回360分析查看结果。
            .ck-step 点击“开始检查”，即开始使用360分析模拟登陆输入的商品页面，在后续操作浏览、加入购物车、下单的过程中，因网站技术实现差异，可能存在跳出360分析的情况，跳出后将无法继续监测，建议直接输入检查商品的页面url，减少跳出情况发生。
            .ck-step
               p 若您的网站不支持iframe嵌套，则无法使用代码自动检查功能，请选择手动检查。
        .ck-tips(v-show="currCkTypeIdx === 2")
            .ck-step 检查注册回传代码中的任意代码，会同时检测基础流量代码，因为基础流量代码是其他代码生效的基础。
            .ck-example
                p 【示例】若您想监测注册成功页面：
                p (1) 点击“开始检查”后进入注册流程的开始页；
                p (2) 从该页面开始实际进行注册操作流程，直到注册成功，代码检查结果会在页面上直接显示，也可在页面点击返回360分析查看结果。
            .ck-step 点击“开始检查”，即开始使用360分析模拟登陆开始检查页面，在后操作注册的过程中，因网站技术实现差异，可能存在跳出360分析情况，跳出后将无法继续监测，建议输入检查开始页面直接输入监测注册成功的前一步页面，减少跳出情况发生。
            .ck-step
               p 若您的网站不支持iframe嵌套，则无法使用代码自动检查功能，请选择手动检查。
</template>

<script>
    import Cookie from 'js-cookie';
    import base64url from 'base64-url';

    export default {
        data() {
            const ckTypes = [{
                 num: 0,
                 desc: '仅检查基础流量代码',
                 tip: '点击“开始检查”将模拟跳转至您输入的页面URL，在该页面上直接显示检查结果',
                 rules: ['et=0']
            }, {
                num: 1,
                desc: '检查商品、订单、购物车回传代码的一种或几种',
                tip: '点击“开始检查”将模拟跳转至您输入的页面URL，您可以从该页面开始实施浏览、加入购物车、下单等行为流程，我们会在您操作过程中检查相应代码是否安装成功',
                rules: ['et=0', 'et=30', 'et=31&order[0].orderType=0', 'et=32']
            }, {
                num: 2,
                desc: '检查注册回传代码',
                tip: '点击“开始检查”将模拟跳转至您输入的页面URL，您可以从该页面开始实施注册行为流程，我们会在您操作过程中检查相应代码是否安装成功',
                rules: ['et=0', 'et=31&order[0].orderType=1']
            }];

            return {
                usrUrl: '',
                ckTypes,
                currCkTypeIdx: 0
            };
        },
        computed: {
            url() {
                let { domain } = this.$store.state.currentDomain;
                let url = this.usrUrl || domain;
                return url.replace(/^https?:\/\//i, '');
            }
        },
        methods: {
            doCheck() {
                let { id } = this.$store.state.currentDomain; 
                let url = this.url;
                let source = /^https?:\/\//.test(url) ? url : ('http://' + url);
                let token = base64url.encode(JSON.stringify({
                  source,
                  domainId: id,
                  rules: this.ckTypes[this.currCkTypeIdx].rules
                }));

                let protocol = /^https:/.test(source) ? 'https://' : 'http://';
                window.x = window.open(protocol + location.host + '/bubble?token=' + token);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// gencode_check.vue?69d0b5fb